import { mapGetters } from 'vuex';

import { formatPrice } from '@/utils/common';

import { types } from '@/store/types';

export const priceFormatterMixin = {
  computed: {
    ...mapGetters({
      priceFormatterMixin__localeWithRegion: types.getters.LOCALE_WITH_REGION
    })
  },
  methods: {
    formatPrice(price, options) {
      if (!price) {
        return '';
      }

      const { fractionalDigits } = options || {};

      return formatPrice({
        price,
        localeWithRegion: this.priceFormatterMixin__localeWithRegion,
        fractionalDigits
      });
    }
  }
};
